import { cva, type VariantProps } from "class-variance-authority";

import type { ReactNode } from "react";

const containerClassName = cva(
  "min-w-0 p-1 rounded-3xl lg:rounded-full border",
  {
    variants: {
      variant: {
        default: "border-black-200 bg-white",
        warning: "border-yellow-400 bg-white",
        danger: "border-red-400 bg-black-50",
        gradient:
          "border-purple-50 bg-[url(/images/free-trial-banner-bg.png)] bg-cover shadow-[0_0_0_0.5px_rgba(69,21,190,0.20)]",
      },
    },
  },
);

const innerContentClassName = cva(
  "rounded-2xl lg:rounded-full px-1.5 lg:px-2.5 gap-1.5 lg:h-8 py-1.5 flex flex-col lg:flex-row lg:items-center",
  {
    variants: {
      variant: {
        default: "bg-white border border-black-200 shadow-sm",
        warning: "bg-white border border-black-200 shadow-sm",
        danger: "bg-white border border-black-200 shadow-sm",
        gradient:
          "bg-[url(/images/free-trial-banner-bg.png)] bg-cover [box-shadow:0_2px_2px_0_rgba(100,44,255,0.16),0_0_0_0.6px_rgba(69,21,190,0.20)]",
      },
    },
  },
);

interface BannerProps
  extends Required<VariantProps<typeof containerClassName>> {
  children: ReactNode;
}

export default function Banner({ children, variant }: BannerProps) {
  return (
    <article className={containerClassName({ variant })}>
      <div className={innerContentClassName({ variant })}>{children}</div>
    </article>
  );
}
